import React, { useState, useEffect } from "react";
import AnnouncementsTable from "./AnnouncementsTable";

const AnnouncementsIntegration = ({type}) => {
  console.log("AnnouncementsIntegration render", type);
  return (
      <AnnouncementsTable type={type} />
    );
};

export default AnnouncementsIntegration;
